module.exports = __webpack_public_path__ + "img/ios-football.4cd5e4dd.svg";